import { render } from "./inputView.vue?vue&type=template&id=f899ba30&scoped=true"
import script from "./inputView.vue?vue&type=script&lang=js"
export * from "./inputView.vue?vue&type=script&lang=js"

import "./inputView.vue?vue&type=style&index=0&id=f899ba30&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f899ba30"]])

export default __exports__